/**
 * SECURITY UTILITY — Pandian Store
 * Prevents open-redirect attacks, XSS, and malicious navigation.
 * All links must pass through safeUrl() before use.
 */

const INTERNAL_ROUTES = [
  '/', '/shop', '/trending', '/catalogue',
  '/cart', '/wishlist', '/checkout', '/dashboard',
  '/privacy-policy', '/refund-policy', '/terms',
];

export function safeUrl(url) {
  if (!url || typeof url !== 'string') return '/';
  const t = url.trim();
  // Block dangerous protocols
  if (/^(javascript|data|vbscript):/i.test(t)) return '/';
  // Block double-encoded sequences
  if (/%2[5-9a-f]/i.test(t)) return '/';
  // Allow safe internal paths
  if (t.startsWith('/')) {
    const isKnown =
      INTERNAL_ROUTES.includes(t) ||
      /^\/product\/(?:\d{1,6}|[a-fA-F0-9]{24})$/.test(t) ||
      /^\/shop(\?.*)?$/.test(t) ||
      /^\/category\/[\w-]+$/.test(t);
    return isKnown ? t : '/';
  }
  return '/';
}

export function safeNavigate(navigate, path) {
  navigate(safeUrl(path));
}

export function safeProductId(id) {
  if (typeof id !== 'string') return null;
  const trimmed = id.trim();
  if (/^\d{1,6}$/.test(trimmed)) return trimmed;
  if (/^[a-fA-F0-9]{24}$/.test(trimmed)) return trimmed;
  return null;
}

export function sanitizeText(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .slice(0, 500);
}
